<template>
  <div class="">
    <div>
      <b-tabs content-class="pt-1" lazy v-model="tabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @click="onTabClick(tab, index)"
          :title="tab.text"
          :active="active(index)"
          title-item-class="lisaweb"
        >
          <keep-alive>
            <component :is="selected"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import AgencySectors from "@/components/profile/sectors/agency/index.vue";
import CompanySectors from "@/components/profile/sectors/company/index.vue";
import ShortcutsAndBreadcrumbsMixin from "@/mixins/ShortcutsAndBreadcrumbsMixin";

export default {
  mixins: [ShortcutsAndBreadcrumbsMixin],
  data() {
    return {
      path: "module.PROF.COMP",
      tabs: [
        { name: "CompanySectors", text: "Comparti di compagnia" },
        { name: "AgencySectors", text: "Comparti di agenzia" },
      ],
      tabsGroup: "Management",
      bcs: [
        {
          text: "Configurazione",
          path: "",
          level: 0,
          disabled: true,
        },
        {
          text: "Configurazione",
          path: "",
          level: 1,
        },
        {
          text: "Comparti Contabili",
          path: "",
          level: 2,
        },
        {
          text: "Comparti di agenzia",
          path: "module.PROF.COMP",
          tab: `#${this.selected}`,
          level: 3,
        },
      ],
      maxLevel: 3,
      selected: "CompanySectors",
      tabIndex: 0,
    };
  },
  components: {
    AgencySectors,
    CompanySectors,
  },
};
</script>
